import { render, staticRenderFns } from "./cities.vue?vue&type=template&id=b6d998dc&"
import script from "./cities.vue?vue&type=script&lang=js&"
export * from "./cities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports